import React from "react";
import BoqItemRow from "../../BoqItemRow/BoqItemRow";

// View row for the room-level BOQ. Renders the shared inline BoqItemRow with
// inline image management + edit/delete. Edit toggles the parent's inline edit
// form (ScopeInlineEditBoqRow), same as the admin portal.
const ScopeBOQItemRow = ({
  boq,
  viewOnly = false,
  onEdit,
  onDelete,
  onImageClick,
  onBudgetUpdated,
  // eslint-disable-next-line no-unused-vars
  isSiteVisit = false,
  // eslint-disable-next-line no-unused-vars
  isUncovered = false,
}) => (
  <BoqItemRow
    boq={boq}
    editableImage={!viewOnly}
    onEdit={!viewOnly && onEdit ? () => onEdit() : undefined}
    onDelete={!viewOnly && onDelete ? () => onDelete() : undefined}
    onImageClick={onImageClick}
    onBudgetUpdated={onBudgetUpdated}
  />
);

export default ScopeBOQItemRow;
